import Inventory2Icon from '@mui/icons-material/Inventory2';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import SellIcon from '@mui/icons-material/Sell';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ScienceIcon from '@mui/icons-material/Science';
import { SummaryWidgetConfig } from '../definitions/inventorySummary';

// Order here drives the left-to-right order of the widgets on the Dashboard.
// Reorder this array to change the display order — nothing else needs to change.
export const SUMMARY_WIDGET_CONFIGS: SummaryWidgetConfig[] = [
  { key: 'total', label: 'Total Sensors', color: '#F27A54', icon: Inventory2Icon },
  { key: 'installed', label: 'Installed', color: '#2E7D32', icon: CheckCircleOutlineIcon },
  { key: 'new', label: 'New', color: '#0277BD', icon: FiberNewIcon },
  { key: 'used', label: 'Used', color: '#1565C0', icon: AutorenewIcon },
  { key: 'rma', label: 'RMA', color: '#6A1B9A', icon: AssignmentReturnIcon },
  { key: 'writtenOff', label: 'Written Off', color: '#C62828', icon: HighlightOffIcon },
  { key: 'testing', label: 'Testing', color: '#F9A825', icon: ScienceIcon },
  { key: 'sold', label: 'Sold', color: '#00897B', icon: SellIcon },
];
